export const searchBoxWidget = {
  init() {
    if (document.body.classList.contains('template-collection')) {
      const searchBoxEl = document.querySelector('.ais-input');
      if (searchBoxEl) {
        searchBoxEl.style.display = 'none';
      }

      const headingEl = document.querySelector('.ais-h2');
      if (headingEl) {
        headingEl.style.display = 'none';
      }
    }
  }
};
